<template>
  <div class="">
    <Navigation />
    <div
      class="relative flex w-full h-full maxwidthscreen mx-auto"
      style="min-height: calc(100vh - 80px)"
    >
      <LeftNavigation />
      <div class="mx-auto h-full" style="width: calc(100vw - 60px)">
        <div class="h-full lg:p-4">
          <!-- overall-student start  -->
          <div
            v-if="selected_url_path === 'overall-student'"
            class="maxwidthscreen containerHead bg-primary2 rounded-md"
            style="height: calc(100vh - 80px)"
          >
            <UserView />
          </div>
          <!-- overall-student end  -->
          <!-- sign-up start  -->
          <div
            v-if="selected_url_path === 'sign-up'"
            class="maxwidthscreen containerHead bg-primary2 rounded-md"
            style="height: calc(100vh - 80px)"
          >
            <SignupView />
          </div>
          <!-- sign-up end  -->
          <!-- application list start  -->
          <div
            v-if="selected_url_path === 'applications'"
            class="maxwidthscreen containerHead bg-primary2 rounded-md"
            style="height: calc(100vh - 80px)"
          >
            <ApplicationView />
          </div>
          <!-- application list end  -->

          <!-- test completed list start -->
          <div
            v-if="selected_url_path === 'test-completed'"
            class="maxwidthscreen containerHead bg-primary2 rounded-md"
            style="height: calc(100vh - 80px)"
          >
            <TestView />
          </div>
          <!-- test completed list end -->
          <!-- download brochure list start  -->
          <div
            v-if="selected_url_path === 'brochure-downloaded'"
            class="maxwidthscreen containerHead bg-primary2 rounded-md"
            style="height: calc(100vh - 80px)"
          >
            <BrochureView />
          </div>
          <!-- download brochure list end  -->
          <!-- enrolled student list start  -->
          <div
            v-if="selected_url_path === 'enrolled-students'"
            class="maxwidthscreen containerHead bg-primary2 rounded-md"
            style="height: calc(100vh - 80px)"
          >
            <EnrollementView />
          </div>
          <!-- enrolled student list end  -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import LeftNavigation from "@/components/LeftNavigationAdminView.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import UserView from "@/components/Logs/UserView.vue";
import ApplicationView from "@/components/Logs/ApplicationView.vue";
import TestView from "../../components/Logs/TestView.vue";
import BrochureView from "../../components/Logs/BrochureView.vue";
import EnrollementView from "../../components/Logs/EnrollementView.vue";
import SignupView from "../../components/Logs/SignupView.vue";
export default {
  name: "StudentView",
  data() {
    return {
      loader: true,
      test_completed: [],
      applied_elective_list: [],
      download_brochure: [],
      user_register_list: [],
      sign_up_user: [],
      all_user: [],
      enrolled_student_list: [],
      total_std_list: [],
      current_position: 0,
      currentPage: 1,
      current_page_number: "",
      perPage: 10,
      test_search: "",
      sign_up_search: "",
      test_application: "",
      user_search: "",
      brochure_search: "",
      selected_url_path: "",
      no_data: require(`${process.env.VUE_APP_NODATA}`),
      page_no: 1,
      user_next: "",
      user_prev: "",
      first_value: 0,
      last_value: 50,
    };
  },
  async created() {
    let url = this.$route.path;
    let url_path = url.split("/summary/")[1];
    this.selected_url_path = url_path;
    // if (url_path == "overall-student") {
    //   this.gatUser();
    // } else if (url_path == "sign-up") {
    //   this.loader = false;
    // } else if (url_path == "applications") {
    //   await this.getApplicationList();
    // } else if (url_path == "test-completed") {
    //   await this.getTestList();
    // } else if (url_path == "brochure-downloaded") {
    //   await this.getBrochureList();
    // } else if (url_path == "enrolled-students") {
    //   await this.getEnrollement();
    // }
  },
  components: {
    Navigation,
    LeftNavigation,
    UserView,
    ApplicationView,
    TestView,
    BrochureView,
    EnrollementView,
    SignupView,
  },
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  // methods: {
  //   async getTestList() {
  //     await axios
  //       .get(`${process.env.VUE_APP_API}/reservation-booking/list/`)
  //       .then((resp) => {
  //         this.select_val = "exam_result";
  //         if (resp.data.status == 200) {
  //           this.test_completed = resp.data.data;
  //           this.loader = false;
  //           console.log("this.test_completed", this.test_completed);
  //         } else {
  //           this.test_completed = "";
  //           this.loader = false;
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   },
  //   async getApplicationList() {
  //     await axios
  //       .get(`${process.env.VUE_APP_API}/selected-elective/list/`)
  //       .then((resp) => {
  //         if (resp.status == 200) {
  //           this.applied_elective_list = resp.data.data;
  //           this.loader = false;
  //           console.log(
  //             "applied_elective_list 242",
  //             this.applied_elective_list
  //           );
  //         } else {
  //           this.applied_elective_list = "";
  //           this.loader = false;
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //     //   await axios
  //     //     .get(
  //     //       `${process.env.VUE_APP_API}/profile_all/?Permission_access=student&lead_type=verified&Key=${this.userInfo.data.token}`
  //     //     )
  //     //     .then((resp) => {
  //     //       this.user_register_list = resp.data;
  //     //       console.log("this.user_register_list 255", this.user_register_list);
  //     //     })
  //     //     .catch((error) => {
  //     //       console.log(error);
  //     //     });
  //   },
  //   async gatUser() {
  //     this.first_value = 1;
  //     await axios
  //       .get(
  //         `${process.env.VUE_APP_API}/profile_all/?Permission_access=student&Key=${this.userInfo.data.token}&page=${this.page_no}`
  //       )
  //       .then((resp) => {
  //         this.total_std_list = resp.data;
  //         this.user_next = resp.data.next;
  //         this.user_prev = resp.data.previous;
  //         this.user_register_list = resp.data.data;
  //         this.current_page_number = resp.data.current_page_number;
  //         this.total_pages = this.user_register_list.total_pages;
  //         this.loader = false;
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   },
  //   async nextUser() {
  //     await axios
  //       .get(`${this.user_next}`)
  //       .then((resp) => {
  //         this.total_std_list = resp.data;
  //         this.user_register_list = resp.data.data;
  //         this.user_next = resp.data.next;
  //         this.user_prev = resp.data.previous;
  //         this.current_page_number = resp.data.current_page_number;
  //         this.first_value = (this.current_page_number - 1) * 50 + 1;
  //         this.last_value = this.current_page_number * 50;
  //         this.total_pages = this.user_register_list.total_pages;
  //         this.loader = false;
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   },
  //   async prevUser() {
  //     await axios
  //       .get(`${this.user_prev}`)
  //       .then((resp) => {
  //         this.total_std_list = resp.data;
  //         this.user_register_list = resp.data.data;
  //         this.user_next = resp.data.next;
  //         this.user_prev = resp.data.previous;
  //         this.current_page_number = resp.data.current_page_number;
  //         this.total_pages = this.user_register_list.total_pages;
  //         this.first_value = (this.current_page_number - 1) * 50 + 1;
  //         this.last_value = (this.last_value / 50 - 1) * 50;
  //         this.loader = false;
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   },
  //   async getBrochureList() {
  //     await axios
  //       .get(`${process.env.VUE_APP_API}/selected-elective-brochure/list/`)
  //       .then((resp) => {
  //         if (resp.status == 200) {
  //           this.download_brochure = resp.data.data;
  //           this.loader = false;
  //           console.log("download_brochure 242", this.download_brochure);
  //         } else {
  //           this.loader = false;
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   },
  //   async getEnrollement() {
  //     await axios
  //       .get(`${process.env.VUE_APP_API}/enrolment/get/`)
  //       .then((resp) => {
  //         if (resp.status == 200) {
  //           this.enrolled_student = resp.data;
  //           console.log("this.enrolled_student", this.enrolled_student);
  //           this.loader = false;
  //         } else {
  //           this.loader = false;
  //         }
  //       });
  //   },
  //   searchTestList() {
  //     axios
  //       .get(
  //         `${process.env.VUE_APP_API}/reservation-booking/list/?search=${this.test_search}`,
  //         {
  //           headers: {
  //             Authorization: `Token ${this.userInfo.data.token}`,
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         if (response.data.status == 200) {
  //           this.leads = response.data.data;
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching leads:", error);
  //       });
  //   },
  // },
};
</script>

<style></style>
